import { ButtonLink } from "../../../../../../components";

export const ActionItems = (
    record,
    setData,
    setIsOpenRemark,
    user,
    dispatch,
    messageApi,
    markAsClosed
  ) => {
    const { status } = record;

    return [
        {
            key: 0,
            label: <ButtonLink>Edit remarks</ButtonLink>,
            onClick: () => {
              setIsOpenRemark(true);
              // setData(record);
            },
        },
        {
            key: 1,
            label: <ButtonLink>Mark as closed</ButtonLink>,
            onClick: () => {
              markAsClosed(record);
            },
        },
    ]

    // const filteredMenuItems = menuItems.filter((item) => item.label !== false);
    // return filteredMenuItems;
}